import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import SectionHeaderLayout from "../../common/components/SectionHeaderLayout";
import RedirectionHandler from "../../common/handlers/RedirectionHandler";
import SectionItem from "./subComponent/SectionItem";
import ServiceSectionCtCard from "./ServiceSectionCtCard";
import { ServiceSectionContent } from "./types";
import { componentNameConstants } from "@repo/analytics/data-layer.constants";
import { DISCOVER_STOCKS_CT, type ServiceSectionCtConfig } from "./discoverStocksCt";

const SERVICE_SECTION_CT_CONFIG: Record<string, ServiceSectionCtConfig> = {
  "discover stocks": DISCOVER_STOCKS_CT,
};

function getServiceSectionCtConfig(
  headerName?: string,
): ServiceSectionCtConfig | undefined {
  const normalizedHeader = headerName?.trim().toLowerCase();
  if (!normalizedHeader) return undefined;
  return SERVICE_SECTION_CT_CONFIG[normalizedHeader];
}

const ServiceSection = ({ content }: { content: ServiceSectionContent }) => {
  const { headerName, list } = content;
  const objValueList = Object.values(list);
  const sectionTitle = headerName ?? "";
  const analyticsConfig = getServiceSectionCtConfig(headerName);

  return (
    <SectionHeaderLayout header={headerName}>
      <div className={`flex gap-[16px] max-md:gap-[8px]`}>
        {objValueList?.map((el, idx) => {
          const url = isOpenInApp() ? el.appdataurl : el.webdataurl;
          const imageUrl = isOpenInApp() ? el.mobileImage : el.desktopimage;

          if (analyticsConfig) {
            return (
              <ServiceSectionCtCard
                key={el.cardTitle ?? idx}
                url={url}
                inNewTab={el.ctaInNewTab}
                ctaText={el.cardTitle}
                isLoginRequired={el.isLoginRequired ?? "false"}
                sectionTitle={sectionTitle}
                analyticsConfig={analyticsConfig}
              >
                <SectionItem
                  url={imageUrl}
                  title={el.cardTitle}
                  description={el.description}
                />
              </ServiceSectionCtCard>
            );
          }

          return (
            <RedirectionHandler
              url={url}
              key={el.cardTitle ?? idx}
              cta_text={el?.cardTitle}
              section_title={componentNameConstants.ADITIONAL_SERVICES}
              isLoginRequired={el?.isLoginRequired ?? "false"}
            >
              <SectionItem
                url={imageUrl}
                title={el.cardTitle}
                description={el.description}
              />
            </RedirectionHandler>
          );
        })}
      </div>
    </SectionHeaderLayout>
  );
};

export default ServiceSection;
